import React from 'react';
import { Box } from '@mui/material';
import { AuditIcon } from '@/components/icons/AuditIcon';
import { PageHeader } from '@/components/layouts/PageHeader';
import AuditTable from '@/components/tables/AuditTable';

export const AuditView = () => {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', pt: 1, pb: 3 }}>
			<PageHeader title='Audit' icon={<AuditIcon />} />
			<Box px={3}>
				<AuditTable />
			</Box>
		</Box>
	);
};
